<!--  -->
<template>
  <div>
    <div v-if="type == 1">
      <el-tabs v-model="activeName">
        <el-tab-pane
          label="风格"
          name="first"
        >
          <div class="dease_box">
            <div
              v-for="item,index in style"
              :key="index"
              class="card"
              @click="deaseitem(item)"
            >
              <p class="demonstration">{{ item.title }}</p>
              <div class="el-image">
                <img
                  :src="item.url"
                  class="elawe"
                  alt=""
                >
              </div>
            </div>
          </div>

        </el-tab-pane>
        <el-tab-pane
          label="节日"
          name="second"
        >
          <div class="dease_box">
            <div
              v-for="item,index in festival"
              :key="index"
              class="card"
              @click="deaseitem(item)"
            >
              <p class="demonstration">{{ item.title }}</p>
              <div class="el-image">
                <img
                  :src="item.url"
                  class="elawe"
                  alt=""
                >
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-else>
      <div class="dease_box">
        <div
          v-for="item,index in banners"
          :key="index"
          class="card"
        >
          <div class="el-image">
            <img
              @click="deaseitemor(item)"
              :src="item"
              class="elawe"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      platformid: null,
      festival: [],
      style: [],
      banners: [],
      activeName: 'first',
      type: null
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(val, type) {
      this.type = null
      this.type = type
      console.log('val', val)
      if (type == 1) {
        this.festival = val.festival
        this.style = val.style
      } else {
        this.banners = val
      }
    },
    deaseitem(item) {
      console.log('item', item)
      this.$emit('close', item)
    },
    deaseitemor(item) {
      console.log('item', item)
      this.$emit('closetwo', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.card {
  margin-bottom: 10px;
  border: 1px solid #eee;
  width: 334px;
  margin-right: 10px;
}
.demonstration {
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
}
.el-image {
  cursor: pointer;
  display: inherit;
}
.elawe {
  width: 100%;
  height: 100%;
}
.dease_box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  /* justify-content: center; */
  height: 680px;
  overflow: hidden;
  overflow-y: scroll;
}
</style>
